import type { Location } from 'common/components/PlaceAutocomplete/location';

export type TravelSearchState = {
  location?: Location;
  checkin?: Date;
  checkout?: Date;
  searchId?: string;
};

export const isTravelSearchState = (
  state: unknown,
): state is TravelSearchState => {
  if (!state || typeof state !== 'object') {
    return false;
  }
  return (
    'location' in state ||
    'checkin' in state ||
    'checkout' in state ||
    'searchId' in state
  );
};
